<template>

  <div id="name-greeting-settings">
    <audio :id="'greeting-audio-'+dirFolder" style="display: none;" src=""></audio>
    <div class="current-greeting-container flex align-center mb-15 mt-0">
      <h4 class="mt-0 mb-0 mr-10">Current Greeting:</h4>
      <div class="current-file" v-if="greetingName || (greetingExists)">
        {{ greetingExists && !greetingChanged ? defaultName : greetingName }}
        <el-button
          v-if="greetingExists && !greetingChanged"
          class="ml-10"
          type="danger"
          circle
          size="mini"
          icon="el-icon-delete"
          style="background-color: #EF5350;"
          @click="removeGreeting"
        >
        </el-button>
      </div>
      <div v-else style="font-style: italic;">
        Upload Or Record A Greeting
      </div>
    </div>

    <div class="greeting-controls-flex flex align-center">
      <el-button
        v-loading="greetingPlayPending"
        id="greeting-play-button"
        class="mr-5"
        :disabled="!!!greetingBlob && !greetingExists"
        :icon="greetingIsPlaying ? 'mdi mdi-pause' : 'mdi mdi-play'"
        @click="greetingIsPlaying ? pauseFile() : playFile()"
        circle
        type="primary"
      >
      </el-button>
      <el-tooltip placement="top" content="Press and Hold To Record" class="flex align-center justify-center">
        <div>
          <VueRecordAudio ref="vueRecorderGreeting" mode="hold" @stream="gotStreamGreeting" @result="onDoneRecordingGreeting"/>
        </div>
      </el-tooltip>
      <el-tooltip placement="top" content="Upload File">
        <el-upload
          class="ml-5 mr-5"
          action="hailFred"
          accept="audio/*"
          :auto-upload="false"
          :on-change="showUploadedGreetingFile"
          :show-file-list="false">
          <el-button
            class="mr-0"
            circle
            icon="el-icon-upload2"
          >
          </el-button>
        </el-upload>
      </el-tooltip>
      <el-tooltip placement="top" content="Download Current" v-if="greetingExists">
        <el-button
          v-loading="greetingDownloadPending"
          circle
          icon="el-icon-download"
          @click="downloadGreeting"
        >
        </el-button>
      </el-tooltip>
      <div class="greeting-save-actions ml-30">
        <el-tooltip placement="top" content="Save Changes" v-if="greetingChanged">
          <el-button
            v-loading="processingRecording"
            type="primary"
            circle
            icon="mdi mdi-content-save"
            @click="saveGreeting"
          >
          </el-button>
        </el-tooltip>
        <el-tooltip placement="top" content="Cancel Changes" v-if="greetingChanged">
          <el-button
            type="danger"
            circle
            icon="mdi mdi-cancel"
            @click="cancelChanges"
          >
          </el-button>
        </el-tooltip>
      </div>

    </div>
  </div>

</template>

<script>

import feathersClient, {hostServer} from "@/feathers/feathers-client";

export default {
  name: 'VmNameGreeting',
  props: {
    existingGreeting: {default: null},
    defaultName: {required: true},
    recordedName: {required: true},
    dirFolder: {required: true},
    tempEnabled: {required: false, default: false}
  },
  data() {
    return {
      greetingIsPlaying: false,
      greetingAudioElement: null,
      greetingBlob: null,
      greetingName: null,
      greetingChanged: false,
      greetingExists: !!this.existingGreeting,
      greetingRecord: this.existingGreeting,
      greetingDownloadPending: false,
      greetingPlayPending: false,
      processingRecording: false
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  watch: {
    existingGreeting() {
      this.greetingRecord = this.existingGreeting;
      this.greetingExists = !!this.existingGreeting;
    }
  },
  methods: {
    gotStreamGreeting(data) {
      this.greetingBlob = null;
      this.greetingName = null;
    },
    onDoneRecordingGreeting(data) {
      this.greetingBlob = data;
      this.greetingAudioElement.src = window.URL.createObjectURL(data);
      this.greetingName = this.recordedName;
      this.greetingChanged = true;
    },
    async playFile() {
      if (!this.greetingName) {
        //fetch the s3 recording set blob and play
        const greeting = await this.fetchGreeting();
        if (greeting) {
          this.greetingIsPlaying = true;
          this.greetingAudioElement.play();
        } else {
          console.log('the file failed to fetch');
        }
      } else {
        this.greetingIsPlaying = true;
        this.greetingAudioElement.play();
      }
    },
    pauseFile() {
      this.greetingIsPlaying = false;
      this.greetingAudioElement.pause();
      this.greetingAudioElement.currentTime = 0;
    },
    removeGreeting() {
      this.$confirm('Remove Name Greeting?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel'
      }).then(() => {
        const recordId = this.getRecordId();
        feathersClient.service('voicemail-messages').remove(recordId, {
          query: {
            mailboxuser: this.user.myExtension.number,
            mailboxContext: this.user.myExtension.tenantCode
          }
        }).then(() => {
          this.clearExistingGreeting();
          this.$emit('greetingRemoved');
        });
      }).catch(() => true);
    },
    cancelChanges() {
      this.greetingBlob = null;
      this.greetingName = null;
      this.greetingChanged = false;
    },
    showUploadedGreetingFile(file) {
      this.greetingBlob = new Blob([file.raw]);
      this.greetingAudioElement.src = window.URL.createObjectURL(this.greetingBlob);
      this.greetingName = file.name;
      this.greetingChanged = true;
    },
    async fetchGreeting() {
      const recordId = this.getRecordId();
      this.setPlayPending();
      return await feathersClient.service('voicemail-messages').get(recordId).then(res => {

        if(!res.recording){
          this.$notify({
            title: 'Not Found',
            message: 'File Not Found.',
            type: 'warning'
          });
          this.setPlayPending();
        } else {
          this.setAudioBlob(res.recording);
          this.setPlayPending();
          return true;
        }

      }).catch(() => false);
    },
    downloadGreeting() {
      const recordId = this.getRecordId();
      this.setDownloadPending();
      feathersClient.service('voicemail-messages').get(recordId).then(res => {

        if(!res.recording) {
          this.$notify({
            title: 'Not Found',
            message: 'File Not Found.',
            type: 'warning'
          });
          this.setDownloadPending();
        } else {
          const link = document.createElement('a');
          link.href = res.recording;
          link.download = 'vmNameGreeting';
          link.click();
          this.setDownloadPending();
        }

      }).catch( () => true);
    },
    saveGreeting() {
      const vmFile = this.greetingBlob;
      this.processingRecording = true;

      let formData = new FormData();
      formData.append('type', 'vmGreeting');
      formData.append('mailboxuser', this.user.myExtension.number);
      formData.append('mailboxContext', this.user.myExtension.tenantCode);
      formData.append('greetingTypes', [this.dirFolder]);
      formData.append('vmFile', vmFile);

      fetch(`${hostServer}/voicemail-messages`, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${this.$store.state.auth.accessToken}`
        }
      }).then(res => res.json()).then((res) => {
        this.processingRecording = false;
        this.greetingExists = true;
        this.greetingRecord = res[0];
        this.$emit('greetingSaved', res[0]);
        this.greetingChanged = false;

        this.$notify({
          type: 'success',
          title: 'Greeting Uploaded',
          message: 'Your greeting was successfully uploaded and applied.'
        });
      });
    },
    getRecordId() {
      return this.greetingRecord.id;
    },
    setAudioBlob(url) {
      this.greetingBlob = url;
      this.greetingAudioElement.src = this.greetingBlob;
    },
    clearExistingGreeting() {
      this.greetingBlob = null;
      this.greetingName = null;
      this.greetingExists = false;
      this.greetingRecord = null;
    },
    setDownloadPending() {
      this.greetingDownloadPending = !this.greetingDownloadPending;
    },
    setPlayPending() {
      this.greetingPlayPending = !this.greetingPlayPending;
    }
  },
  mounted() {
    this.greetingAudioElement = document.getElementById(`greeting-audio-${this.dirFolder}`);
    this.greetingAudioElement.addEventListener('ended', () => {
      this.greetingIsPlaying = false;
    });
  },
  beforeDestroy() {
    this.greetingAudioElement.removeEventListener('ended', () => true);
  }
}

</script>
